import { getDate } from '../../../../../utils/dateUtils';

const PaymentReceivedDetailTable = ({
	tableColumns = [],
	tableRows = [],
	setIsSalesDrawerOpen,
	setIsDrawerOpen,
	setInvoiceId,
}) => {
	return (
		<table
			style={{
				width: '100%',
				border: '1px solid #dee2e6',
				borderCollapse: 'collapse',
				textAlign: 'left',
			}}
		>
			<thead>
				<tr style={{ backgroundColor: '#f1f3f5', fontWeight: 'bold', color: '#555B67' }}>
					{tableColumns.map((col, index) => (
						<th
							key={index}
							style={{
								padding: '8px',
								border: '1px solid #dee2e6',
								textAlign: col === 'INVOICE NUMBER' || col === 'INVOICE DATE' ? 'left' : 'right',
							}}
						>
							{col}
						</th>
					))}
				</tr>
			</thead>
			<tbody>
				{tableRows.map((pb) => (
					<tr>
						<td
							style={{
								padding: '8px',
								border: '1px solid #dee2e6',
								textAlign: 'left',
								color: '#3B58FF',
								cursor: 'pointer',
							}}
							onClick={() => {
								setIsDrawerOpen(false);
								setInvoiceId(pb?.invoice_id);
								setIsSalesDrawerOpen(true);
							}}
						>
							{pb?.invoice_number}
						</td>
						<td
							style={{
								padding: '8px',
								border: '1px solid #dee2e6',
								textAlign: 'left',
								color: '#555B67',
							}}
						>
							{getDate(pb?.invoice_date)}
						</td>
						<td
							style={{
								padding: '8px',
								border: '1px solid #dee2e6',
								textAlign: 'right',
								color: '#555B67',
							}}
						>
							{Number(pb?.invoice_amount).toFixed(2)}
						</td>
						<td
							style={{
								padding: '8px',
								border: '1px solid #dee2e6',
								textAlign: 'right',
								color: '#555B67',
							}}
						>
							{Number(pb?.payment_amount).toFixed(2)}
						</td>
					</tr>
				))}
			</tbody>
		</table>
	);
};
export default PaymentReceivedDetailTable;
